import React from 'react';
import classes from './ContentCategorySelector.module.css';
import ContentTypes from 'components/UI/ContentTypes/ContentTypes';

const contentCategorySelector = (props) => {
  return (
    <div className={classes.ContentCategories}>
      <ContentTypes
        selectedCategory={props.selectedCategory}
        selectedCategories={props.selectedCategories}
        shortWindow={props.shortWindow}
        clicked={props.clicked}
        classIdentifier={props.type ? props.type : 'ContentCategorySelector'}
      />
    </div>
  );
};

export default contentCategorySelector;
